import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import Sidebar from '../../../Seller/Sidebar';
import ProfileWish from '../Profile/ProfileWish';

const ProfilePropLiked = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        minHeight: '100vh',
        background: '#F9FAFB',
        gap: '20px',
        boxSizing: 'border-box',
        flexDirection: { xs: 'column', md: 'row' },
        mt: { xs: '64px', md: '15px' },
      }}
    >
      {/* ✅ Hide Sidebar on mobile */}
      {!isMobile && (
        <Sidebar
          sx={{
            width: { xs: '100%', md: 'auto' },
            ml: { xs: 0, md: '80px' },
            mt: { xs: 0, md: '25px' },
          }}
        />
      )}

      <ProfileWish />
    </Box>
  );
};

export default ProfilePropLiked;